import { inject } from '@angular/core';
import { CanActivateFn, CanDeactivateFn } from '@angular/router';
import { ConfirmationService } from 'primeng/api';

export interface CanComponentDeactivate {
  hasUnsavedChanges: () => boolean;
}

export const ExitGuard: CanDeactivateFn<CanComponentDeactivate> = (component) => {
  const confirmationService = inject(ConfirmationService);

    if (!component.hasUnsavedChanges()) {
      return true;
    }

    return new Promise<boolean>((resolve) => {
      confirmationService.confirm({
        message: 'Are you sure you want to leave?',
        header: 'Exit Confirmation',
        icon: 'pi pi-exclamation-triangle',
        rejectButtonProps: {
            label: 'Cancel',
            severity: 'secondary',
            outlined: true
        },
        acceptButtonProps: {
            label: 'Exit',
            severity: 'danger'
        },
        accept: () => resolve(true),
        reject: () => resolve(false)
      });
    });
};
